import Vue from 'vue'
import queryString from 'query-string'

const VueQueryString = new Vue()
VueQueryString.install = function(Vue, options) {
  Vue.prototype.$queryString = queryString
}

Vue.use(VueQueryString)
